import { useTranslation } from "react-i18next";

export const Error404 = () => {
  const { t } = useTranslation();

  return (
    <div className="title-xl mx-auto my-auto text-center">
      {t("error.page_not_found")}
    </div>
  );
};
